export default __webpack_public_path__ + "static/media/scb-logo.53a0d1e5.png";